import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import "../Styles/Service.css";
import ModelTest from "./ModelTest";
import { AppContext } from "../Context/Provider";

const Services = () => {
  const { FetchHomeService, HomeServices } = useContext(AppContext);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    FetchHomeService();
  }, []);

  const handleCardClick = (service) => {
    if (service.link === "#") {
      setSelectedService(service);
      setIsModalVisible(true);
    } else if (service.externalLink) {
      window.open(service.link, "_blank");
    } else {
      window.location.href = service.link;
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto text-center">
        {/* Section Header */}
        <h2 
          className="text-4xl font-bold font-poppins mb-4" 
          style={{ color: "#090f4e" }}
        >
          Our services
        </h2>
        
        {/* Added Description from Image */}
        <p
          className="mx-auto mb-12 font-poppins px-4"
          style={{ 
            color: "#6b7280", 
            fontWeight: 400, 
            fontSize: "16px",
            maxWidth: "700px",
            lineHeight: "1.6"
          }}
        >
         We offer a variety of services designed to make your life easier. Our services bring you convenience, speed, and an all-in-one solution to manage your everyday needs in one place.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-16">
          {HomeServices?.map((service, index) => (
            <div
              key={index}
              className="p-8 rounded-3xl text-left bg-white transition-all duration-300 hover:shadow-xl border border-gray-100"
              style={{ 
                cursor: "pointer",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
              }}
              onClick={() => handleCardClick(service)}
            >
              {/* Light Blue Icon Container */}
              <div 
                className="flex items-center justify-center rounded-3xl mb-6"
                style={{ 
                  backgroundColor: "#f4f9ff", 
                  width: "100px", 
                  height: "100px" 
                }}
              >
                <LazyLoad height={60} offset={100} once>
                  <img
                    src={service.fileName}
                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                    alt={service.title}
                  />
                </LazyLoad>
              </div>

              <h3
                className="text-xl font-bold font-poppins mb-2"
                style={{ color: "#090f4e" }}
              >
                {service.title}
              </h3>
              
              <p
                className="font-poppins text-gray-500"
                style={{ fontSize: "14px", lineHeight: "1.5" }}
              >
                {service.description}
              </p>

              {/* Keep existing logic for Link but styled subtly */}
              <Link
                to={service.externalLink ? "#" : service.link}
                className="mt-6 inline-block font-poppins font-bold text-blue-600"
                style={{ fontSize: "13px", visibility: "hidden" }} // Keeping logic but hiding per visual design
                onClick={(e) => {
                  if (service.externalLink) {
                    e.preventDefault();
                    window.open(service.link, "_blank");
                  }
                }}
              >
                Learn More
              </Link>
            </div>
          ))}
        </div>

        {isModalVisible && (
          <ModelTest
            setIsVisible={setIsModalVisible}
            isVisible={isModalVisible}
            onClose={closeModal}
          />
        )}
      </div>
    </section>
  );
};

export default Services;